import { session } from '../Service/APIService';
import RefreshToken from './RefreshToken';

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

async function Auth() {
  const userObj = session.user();
  const accessToken = userObj ? userObj.token : null;

  if (!accessToken) {
    return false; // No token, authentication failed
  }

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  // Check if token is expired
  if (decoded.exp < currentTime) {
    window.location.href = '/login';
    return false; // Token expired
  }

  // Check if token will expire in the next 60 seconds
  if (decoded.exp - currentTime < 60) {
    const toknRes = await RefreshToken();
    return toknRes; // Return the result of refreshing the token
  }

  return true; // Token is valid and not expiring soon
}

export default Auth;
